export const allItems = [
  { _id: 119, title: "Music, CDs & Vinyl" },
  { _id: 120, title: "Pet Supplies" },
  { _id: 121, title: "Prime Video" },
  { _id: 122, title: "Software" },
  { _id: 123, title: "Sports & Outdoors" },
  { _id: 124, title: "Tools & Home Improvement" },
  { _id: 125, title: "Toys & Games" },
  { _id: 126, title: "Video Games" },
  { _id: 127, title: "Women's Fashion" },
];
